import CompareWorker from 'worker-loader!@/worker/compare.worker';
import runWorker from './runWorker';

export default function compareImages(first: ArrayBuffer, second: ArrayBuffer, signal: AbortSignal) {
    return runWorker<number>(new CompareWorker(), { first, second }, [first, second], signal);
}
